// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const APP_INFO = {
    "version": "0.0.1",
    "sha": "a5ea0ec737732c0b1ee391803a1891b49b39dc64",
    "authorDate": null
};
/* tslint:enable */
